module.exports = {
    baseUrl: process.env.VUE_APP_DIR_DEPLOY     
}